import React from 'react'
import under from '../img/under.png'

const Construction = () => {
  return (
<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' ,marginTop:"100px" }}>
  <img src={under} alt="" style={{ height: '450px' }} className='col-lg-4 col-md-6 col-12' />
</div>
  )
}

export default Construction
